import {
  CHANGE_EMAIL_STEP_ONE,
  CHANGE_EMAIL_STEP_ONE_FAILURE,
  CHANGE_EMAIL_STEP_ONE_SUCCESS,
  CHANGE_EMAIL_STEP_TWO,
  CHANGE_EMAIL_STEP_TWO_FAILURE,
  CHANGE_EMAIL_STEP_TWO_SUCCESS,
  CHANGE_INPUT,
  CHANGE_INPUT_ERROR,
  CHANGE_STEP,
  RESET_FORM_STATE,
  RESET_INPUT_ERRORS,
  RESET_STATE,
  RESET_STATUS,
  VERIFY_RECAPTCHA,
  VERIFY_RECAPTCHA_FAILURE,
  VERIFY_RECAPTCHA_SUCCESS,
} from './constants';

export function changeEmailStepOne({ navigationType = 'navigate', requestBody }) {
  return {
    payload: { navigationType, requestBody },
    type: CHANGE_EMAIL_STEP_ONE,
  };
}

export function changeEmailStepOneFailure({ bannerError, error, validationErrors }) {
  return {
    payload: { bannerError, error, validationErrors },
    type: CHANGE_EMAIL_STEP_ONE_FAILURE,
  };
}

export function changeEmailStepOneSuccess(token) {
  return {
    payload: { token },
    type: CHANGE_EMAIL_STEP_ONE_SUCCESS,
  };
}

export function changeEmailStepTwo({ navigationType = 'navigate', requestBody }) {
  return {
    payload: { navigationType, requestBody },
    type: CHANGE_EMAIL_STEP_TWO,
  };
}

export function changeEmailStepTwoFailure({ bannerError, error, validationErrors }) {
  return {
    payload: { bannerError, error, validationErrors },
    type: CHANGE_EMAIL_STEP_TWO_FAILURE,
  };
}

export function changeEmailStepTwoSuccess() {
  return { type: CHANGE_EMAIL_STEP_TWO_SUCCESS };
}

export function changeInput({
  field,
  form,
  value,
}) {
  return {
    payload: {
      field,
      form,
      value,
    },
    type: CHANGE_INPUT,
  };
}

export function changeInputError({
  field,
  form,
  value,
}) {
  return {
    payload: {
      field,
      form,
      value,
    },
    type: CHANGE_INPUT_ERROR,
  };
}

export function changeStep(step) {
  return {
    payload: { step },
    type: CHANGE_STEP,
  };
}

export function resetFormState(payload) {
  return {
    payload,
    type: RESET_FORM_STATE,
  };
}

export function resetInputErrors(payload) {
  return {
    payload,
    type: RESET_INPUT_ERRORS,
  };
}

export function resetState() {
  return { type: RESET_STATE };
}

export function resetStatus() {
  return { type: RESET_STATUS };
}

/**
 * @description On reCaptcha submit, action will send a request to gateway server to verify
 * reCaptcha response
 */
export function verifyRecaptcha(payload) {
  return {
    payload,
    type: VERIFY_RECAPTCHA,
  };
}

/**
 * @description On failed reCaptcha verification request, action will update the redux store
 */
export function verifyRecaptchaFailure({ error }) {
  return {
    payload: { error },
    type: VERIFY_RECAPTCHA_FAILURE,
  };
}

/**
 * @description On successful reCaptcha verification request, action will update the redux store
 */
export function verifyRecaptchaSuccess() {
  return { type: VERIFY_RECAPTCHA_SUCCESS };
}
